module.exports = __webpack_public_path__ + "media/printed-materials/fastweb-part-time-jobs-poster-a7399b20.png";